import ApiDefault from "../../ApiDefault";

export default function ApiIntegrations() {
    const apiDefault = ApiDefault("v2/system/integrations");

    return {
        apiDefault,
    };
}
